"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var User = function User(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 16H8C6.93915 16.0001 5.92177 16.4215 5.17164 17.1716C4.42151 17.9218 4.00006 18.9392 4 20V20.9434C6.19981 22.9118 9.0481 24 12 24C14.9519 24 17.8002 22.9118 20 20.9434V20.0043V20C19.9999 18.9392 19.5785 17.9218 18.8284 17.1716C18.0782 16.4215 17.0608 16.0001 16 16Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.foregroundColor
  }))));
};

User.defaultProps = {
  altText: "User",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
User.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = User;
exports.default = _default;